module.exports = __webpack_public_path__ + "assets/servileasing_web2.268b22d1e88594351a6dbfbdbdf20f4f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/servileasing_web2.png
 ** module id = 852
 ** module chunks = 0
 **/